import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import type { Action } from '../../state/actions';
import { getProjectIdSelector } from '../../state/context/selectors.tsx';
import type { AppState } from '../../state/types';
import appStartedEpic from './app-started';
import detailsSavedEpic from './details-saved';
import projectDeletedEpic from './project-deleted';
import triggerAnalytics from './trigger-analytics';
import type { AnalyticEvent } from './types';

type EpicFunction = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<AppState>,
) => Observable<AnalyticEvent>;

/**
 * Takes an array of analytic epics, creates the observables and merges those
 * observables into a single stream. Each time that stream emits, an analytic
 * event will be sent with the provided name and data (optional).
 */
export const combineAnalyticEpics = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<AppState>,
	epics: EpicFunction[],
) =>
	Observable.merge(...epics.map((epic) => epic(action$, store)))
		.do(({ event, data }) => {
			triggerAnalytics(event, { ...data, projectId: getProjectIdSelector(store.getState()) });
		})
		.ignoreElements();

/**
 * Combines all the analytic related epics into one.
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, store: MiddlewareAPI<AppState>) =>
	combineAnalyticEpics(action$, store, [appStartedEpic, detailsSavedEpic, projectDeletedEpic]);
